export function sortInvoicesByCreatedAt(invoices) {
  return [...invoices].sort((a, b) => (a.createdAt ?? '').localeCompare(b.createdAt ?? ''));
}
